<br-modal 
  
  [config]="config" 
  (action)="onAction($event)" 
  (close)="onClose()">
</br-modal>
